export default "__VITE_ASSET__3ba94d56__"